/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateDashboardBannerBody } from '../models';
// @ts-ignore
import type { DashboardBannerSub } from '../models';
// @ts-ignore
import type { DeleteDashboardBannerResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetActivePopupBannerResponse } from '../models';
// @ts-ignore
import type { GetApplicantDashboardResponse } from '../models';
// @ts-ignore
import type { GetDashboardBannersResponse } from '../models';
// @ts-ignore
import type { GetPendingCertificateClaimsResponse } from '../models';
// @ts-ignore
import type { ReorderDashboardBannersBody } from '../models';
// @ts-ignore
import type { UpdateDashboardBannerBody } from '../models';
// @ts-ignore
import type { UploadDashboardBannerImageResponse } from '../models';
/**
 * DashboardApiApi - axios parameter creator
 */
export const DashboardApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateDashboardBannerBody} createDashboardBannerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiCreateDashboardBanner: async (createDashboardBannerBody: CreateDashboardBannerBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createDashboardBannerBody' is not null or undefined
            assertParamExists('dashboardApiCreateDashboardBanner', 'createDashboardBannerBody', createDashboardBannerBody)
            const localVarPath = `/admin/dashboard-banner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDashboardBannerBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bannerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiDeleteDashboardBanner: async (bannerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bannerId' is not null or undefined
            assertParamExists('dashboardApiDeleteDashboardBanner', 'bannerId', bannerId)
            const localVarPath = `/admin/dashboard-banner/{banner_id}`
                .replace('{banner_id}', encodeURIComponent(String(bannerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiGetActivePopupBanner: async (page: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('dashboardApiGetActivePopupBanner', 'page', page)
            const localVarPath = `/popup-banner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<DashboardApiGetApplicantDashboardDataSectionsEnum>} [sections] 
         * @param {Array<string>} [skillIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiGetApplicantDashboardData: async (sections?: Array<DashboardApiGetApplicantDashboardDataSectionsEnum>, skillIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/applicant/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (sections) {
                localVarQueryParameter['sections'] = sections;
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids'] = skillIds;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [bannerType] 
         * @param {boolean} [isActive] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [targetUserType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiGetDashboardBanners: async (bannerType?: string, isActive?: boolean, page?: number, pageSize?: number, targetUserType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/dashboard-banner`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (bannerType !== undefined) {
                localVarQueryParameter['banner_type'] = bannerType;
            }

            if (isActive !== undefined) {
                localVarQueryParameter['is_active'] = isActive;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (targetUserType !== undefined) {
                localVarQueryParameter['target_user_type'] = targetUserType;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiGetPendingCertificateClaims: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/applicant/dashboard/certificate-claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReorderDashboardBannersBody} reorderDashboardBannersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiReorderDashboardBanners: async (reorderDashboardBannersBody: ReorderDashboardBannersBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reorderDashboardBannersBody' is not null or undefined
            assertParamExists('dashboardApiReorderDashboardBanners', 'reorderDashboardBannersBody', reorderDashboardBannersBody)
            const localVarPath = `/admin/dashboard-banner/reorder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reorderDashboardBannersBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} bannerId 
         * @param {UpdateDashboardBannerBody} updateDashboardBannerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiUpdateDashboardBanner: async (bannerId: string, updateDashboardBannerBody: UpdateDashboardBannerBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'bannerId' is not null or undefined
            assertParamExists('dashboardApiUpdateDashboardBanner', 'bannerId', bannerId)
            // verify required parameter 'updateDashboardBannerBody' is not null or undefined
            assertParamExists('dashboardApiUpdateDashboardBanner', 'updateDashboardBannerBody', updateDashboardBannerBody)
            const localVarPath = `/admin/dashboard-banner/{banner_id}`
                .replace('{banner_id}', encodeURIComponent(String(bannerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDashboardBannerBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiUploadDashboardBannerImage: async (imageFile: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'imageFile' is not null or undefined
            assertParamExists('dashboardApiUploadDashboardBannerImage', 'imageFile', imageFile)
            const localVarPath = `/admin/dashboard-banner/upload-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (imageFile !== undefined) { 
                localVarFormParams.append('image_file', imageFile as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApiApi - functional programming interface
 */
export const DashboardApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateDashboardBannerBody} createDashboardBannerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardApiCreateDashboardBanner(createDashboardBannerBody: CreateDashboardBannerBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardBannerSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardApiCreateDashboardBanner(createDashboardBannerBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApiApi.dashboardApiCreateDashboardBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bannerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardApiDeleteDashboardBanner(bannerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteDashboardBannerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardApiDeleteDashboardBanner(bannerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApiApi.dashboardApiDeleteDashboardBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} page 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardApiGetActivePopupBanner(page: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActivePopupBannerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardApiGetActivePopupBanner(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApiApi.dashboardApiGetActivePopupBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<DashboardApiGetApplicantDashboardDataSectionsEnum>} [sections] 
         * @param {Array<string>} [skillIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardApiGetApplicantDashboardData(sections?: Array<DashboardApiGetApplicantDashboardDataSectionsEnum>, skillIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetApplicantDashboardResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardApiGetApplicantDashboardData(sections, skillIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApiApi.dashboardApiGetApplicantDashboardData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [bannerType] 
         * @param {boolean} [isActive] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [targetUserType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardApiGetDashboardBanners(bannerType?: string, isActive?: boolean, page?: number, pageSize?: number, targetUserType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDashboardBannersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardApiGetDashboardBanners(bannerType, isActive, page, pageSize, targetUserType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApiApi.dashboardApiGetDashboardBanners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardApiGetPendingCertificateClaims(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPendingCertificateClaimsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardApiGetPendingCertificateClaims(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApiApi.dashboardApiGetPendingCertificateClaims']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ReorderDashboardBannersBody} reorderDashboardBannersBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardApiReorderDashboardBanners(reorderDashboardBannersBody: ReorderDashboardBannersBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteDashboardBannerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardApiReorderDashboardBanners(reorderDashboardBannersBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApiApi.dashboardApiReorderDashboardBanners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} bannerId 
         * @param {UpdateDashboardBannerBody} updateDashboardBannerBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardApiUpdateDashboardBanner(bannerId: string, updateDashboardBannerBody: UpdateDashboardBannerBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DashboardBannerSub>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardApiUpdateDashboardBanner(bannerId, updateDashboardBannerBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApiApi.dashboardApiUpdateDashboardBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} imageFile 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dashboardApiUploadDashboardBannerImage(imageFile: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadDashboardBannerImageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dashboardApiUploadDashboardBannerImage(imageFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApiApi.dashboardApiUploadDashboardBannerImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardApiApi - factory interface
 */
export const DashboardApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiApiFp(configuration)
    return {
        /**
         * 
         * @param {DashboardApiApiDashboardApiCreateDashboardBannerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiCreateDashboardBanner(requestParameters: DashboardApiApiDashboardApiCreateDashboardBannerRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardBannerSub> {
            return localVarFp.dashboardApiCreateDashboardBanner(requestParameters.createDashboardBannerBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiApiDashboardApiDeleteDashboardBannerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiDeleteDashboardBanner(requestParameters: DashboardApiApiDashboardApiDeleteDashboardBannerRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteDashboardBannerResponse> {
            return localVarFp.dashboardApiDeleteDashboardBanner(requestParameters.bannerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiApiDashboardApiGetActivePopupBannerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiGetActivePopupBanner(requestParameters: DashboardApiApiDashboardApiGetActivePopupBannerRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetActivePopupBannerResponse> {
            return localVarFp.dashboardApiGetActivePopupBanner(requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiApiDashboardApiGetApplicantDashboardDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiGetApplicantDashboardData(requestParameters: DashboardApiApiDashboardApiGetApplicantDashboardDataRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetApplicantDashboardResponse> {
            return localVarFp.dashboardApiGetApplicantDashboardData(requestParameters.sections, requestParameters.skillIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiApiDashboardApiGetDashboardBannersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiGetDashboardBanners(requestParameters: DashboardApiApiDashboardApiGetDashboardBannersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetDashboardBannersResponse> {
            return localVarFp.dashboardApiGetDashboardBanners(requestParameters.bannerType, requestParameters.isActive, requestParameters.page, requestParameters.pageSize, requestParameters.targetUserType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiGetPendingCertificateClaims(options?: RawAxiosRequestConfig): AxiosPromise<GetPendingCertificateClaimsResponse> {
            return localVarFp.dashboardApiGetPendingCertificateClaims(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiApiDashboardApiReorderDashboardBannersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiReorderDashboardBanners(requestParameters: DashboardApiApiDashboardApiReorderDashboardBannersRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteDashboardBannerResponse> {
            return localVarFp.dashboardApiReorderDashboardBanners(requestParameters.reorderDashboardBannersBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiApiDashboardApiUpdateDashboardBannerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiUpdateDashboardBanner(requestParameters: DashboardApiApiDashboardApiUpdateDashboardBannerRequest, options?: RawAxiosRequestConfig): AxiosPromise<DashboardBannerSub> {
            return localVarFp.dashboardApiUpdateDashboardBanner(requestParameters.bannerId, requestParameters.updateDashboardBannerBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DashboardApiApiDashboardApiUploadDashboardBannerImageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dashboardApiUploadDashboardBannerImage(requestParameters: DashboardApiApiDashboardApiUploadDashboardBannerImageRequest, options?: RawAxiosRequestConfig): AxiosPromise<UploadDashboardBannerImageResponse> {
            return localVarFp.dashboardApiUploadDashboardBannerImage(requestParameters.imageFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for dashboardApiCreateDashboardBanner operation in DashboardApiApi.
 */
export interface DashboardApiApiDashboardApiCreateDashboardBannerRequest {
    readonly createDashboardBannerBody: CreateDashboardBannerBody
}

/**
 * Request parameters for dashboardApiDeleteDashboardBanner operation in DashboardApiApi.
 */
export interface DashboardApiApiDashboardApiDeleteDashboardBannerRequest {
    readonly bannerId: string
}

/**
 * Request parameters for dashboardApiGetActivePopupBanner operation in DashboardApiApi.
 */
export interface DashboardApiApiDashboardApiGetActivePopupBannerRequest {
    readonly page: string
}

/**
 * Request parameters for dashboardApiGetApplicantDashboardData operation in DashboardApiApi.
 */
export interface DashboardApiApiDashboardApiGetApplicantDashboardDataRequest {
    readonly sections?: Array<DashboardApiGetApplicantDashboardDataSectionsEnum>

    readonly skillIds?: Array<string>
}

/**
 * Request parameters for dashboardApiGetDashboardBanners operation in DashboardApiApi.
 */
export interface DashboardApiApiDashboardApiGetDashboardBannersRequest {
    readonly bannerType?: string

    readonly isActive?: boolean

    readonly page?: number

    readonly pageSize?: number

    readonly targetUserType?: string
}

/**
 * Request parameters for dashboardApiReorderDashboardBanners operation in DashboardApiApi.
 */
export interface DashboardApiApiDashboardApiReorderDashboardBannersRequest {
    readonly reorderDashboardBannersBody: ReorderDashboardBannersBody
}

/**
 * Request parameters for dashboardApiUpdateDashboardBanner operation in DashboardApiApi.
 */
export interface DashboardApiApiDashboardApiUpdateDashboardBannerRequest {
    readonly bannerId: string

    readonly updateDashboardBannerBody: UpdateDashboardBannerBody
}

/**
 * Request parameters for dashboardApiUploadDashboardBannerImage operation in DashboardApiApi.
 */
export interface DashboardApiApiDashboardApiUploadDashboardBannerImageRequest {
    readonly imageFile: File
}

/**
 * DashboardApiApi - object-oriented interface
 */
export class DashboardApiApi extends BaseAPI {
    /**
     * 
     * @param {DashboardApiApiDashboardApiCreateDashboardBannerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dashboardApiCreateDashboardBanner(requestParameters: DashboardApiApiDashboardApiCreateDashboardBannerRequest, options?: RawAxiosRequestConfig) {
        return DashboardApiApiFp(this.configuration).dashboardApiCreateDashboardBanner(requestParameters.createDashboardBannerBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiApiDashboardApiDeleteDashboardBannerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dashboardApiDeleteDashboardBanner(requestParameters: DashboardApiApiDashboardApiDeleteDashboardBannerRequest, options?: RawAxiosRequestConfig) {
        return DashboardApiApiFp(this.configuration).dashboardApiDeleteDashboardBanner(requestParameters.bannerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiApiDashboardApiGetActivePopupBannerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dashboardApiGetActivePopupBanner(requestParameters: DashboardApiApiDashboardApiGetActivePopupBannerRequest, options?: RawAxiosRequestConfig) {
        return DashboardApiApiFp(this.configuration).dashboardApiGetActivePopupBanner(requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiApiDashboardApiGetApplicantDashboardDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dashboardApiGetApplicantDashboardData(requestParameters: DashboardApiApiDashboardApiGetApplicantDashboardDataRequest = {}, options?: RawAxiosRequestConfig) {
        return DashboardApiApiFp(this.configuration).dashboardApiGetApplicantDashboardData(requestParameters.sections, requestParameters.skillIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiApiDashboardApiGetDashboardBannersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dashboardApiGetDashboardBanners(requestParameters: DashboardApiApiDashboardApiGetDashboardBannersRequest = {}, options?: RawAxiosRequestConfig) {
        return DashboardApiApiFp(this.configuration).dashboardApiGetDashboardBanners(requestParameters.bannerType, requestParameters.isActive, requestParameters.page, requestParameters.pageSize, requestParameters.targetUserType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dashboardApiGetPendingCertificateClaims(options?: RawAxiosRequestConfig) {
        return DashboardApiApiFp(this.configuration).dashboardApiGetPendingCertificateClaims(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiApiDashboardApiReorderDashboardBannersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dashboardApiReorderDashboardBanners(requestParameters: DashboardApiApiDashboardApiReorderDashboardBannersRequest, options?: RawAxiosRequestConfig) {
        return DashboardApiApiFp(this.configuration).dashboardApiReorderDashboardBanners(requestParameters.reorderDashboardBannersBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiApiDashboardApiUpdateDashboardBannerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dashboardApiUpdateDashboardBanner(requestParameters: DashboardApiApiDashboardApiUpdateDashboardBannerRequest, options?: RawAxiosRequestConfig) {
        return DashboardApiApiFp(this.configuration).dashboardApiUpdateDashboardBanner(requestParameters.bannerId, requestParameters.updateDashboardBannerBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DashboardApiApiDashboardApiUploadDashboardBannerImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dashboardApiUploadDashboardBannerImage(requestParameters: DashboardApiApiDashboardApiUploadDashboardBannerImageRequest, options?: RawAxiosRequestConfig) {
        return DashboardApiApiFp(this.configuration).dashboardApiUploadDashboardBannerImage(requestParameters.imageFile, options).then((request) => request(this.axios, this.basePath));
    }
}

export const DashboardApiGetApplicantDashboardDataSectionsEnum = {
    Core: 'core',
    Learning: 'learning',
    Profile: 'profile',
} as const;
export type DashboardApiGetApplicantDashboardDataSectionsEnum = typeof DashboardApiGetApplicantDashboardDataSectionsEnum[keyof typeof DashboardApiGetApplicantDashboardDataSectionsEnum];
